<section class="section" *ngFor="let homeBox of homeBoxes">
    <h2 class="subtitle title-header">{{ homeBox.section }}</h2>
    <div class="columns is-multiline">
      <div class="column is-3-fullhd is-3-widescreen is-4-desktop is-6-tablet" *ngFor="let box of homeBox.boxes">
        <div class="option-boxes">
          <a class="option-box" *ngIf="box.isLink" [href]="box.link" target="_blank">
            <fa-duotone-icon class="box-icon" [icon]="box.icon" [swapOpacity]="box.swapOpacity"></fa-duotone-icon>
            <span class="box-title">{{ box.name }}</span>
            <fa-icon class="icon-link" [icon]="faArrowUpRightFromSquare"></fa-icon>
          </a>
          <div class="option-box" *ngIf="!box.isLink" [routerLink]="box.routerLink">
            <fa-duotone-icon class="box-icon" [icon]="box.icon"  [swapOpacity]="box.swapOpacity"></fa-duotone-icon>
            <span class="box-title">{{ box.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

